import { useQuery } from '@tanstack/react-query'

import { ClientInvoicesByPeriodService } from '../services/client_invoices_by_period.service'
import { getServiceOptions, mapInvoiceToCustomInvoices } from '../mappers'
import { ClientInvoicesByPeriodSearchOptions, InvoiceClientDto } from '../types/api'
import { TCustomInvoiceDto } from '../types/general'
import { defaultQueryOptions } from './common'

export const useClientBookingInvoices = (locationName: string, options: ClientInvoicesByPeriodSearchOptions) => {
  return useQuery<{ results: TCustomInvoiceDto[]; nextToken: string | null }>({
    queryKey: ['clientBookingInvoices', locationName, options],
    queryFn: async () => {
      const raw = await ClientInvoicesByPeriodService.getData(locationName, getServiceOptions(options))

      return {
        results: (raw.results as InvoiceClientDto[]).flatMap(mapInvoiceToCustomInvoices),
        nextToken: raw.nextToken ?? null,
      }
    },
    ...defaultQueryOptions,
  })
}
